import { StyledButton } from "./Button.styles";
import { ButtonProps } from "../../../interfaces";

export const Button = ({
  variant = "primary",
  isLoading,
  children,
  disabled,
  fullWidth,
  ...props
}: ButtonProps) => {
  return (
    <StyledButton
      $variant={variant}
      $fullWidth={fullWidth}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? "..." : children}
    </StyledButton>
  );
};
